import { useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { useAddUserMutation } from "../../features/api/userApi";
import { toast } from "react-toastify";
const CreateUser = () => {
  const [role, setUserType] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [pass, setPassword] = useState("");
  const [conPass, setConPassword] = useState("");
  const userType = ["sadmin", "admin", "user"];
  const [error, setError] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const navigate = useNavigate();
  const [createNewUser] = useAddUserMutation();
  const handleCreate = async () => {
    if (pass !== conPass) {
      setError("Password did not matched!!");
    } else {
      const formData = new FormData();
      formData.append("role", role);
      formData.append("name", name);
      formData.append("email", email);
      if (image) formData.append("signature", image);
      formData.append("pass", pass);

      try {
        // const data = { role, name, email, image, pass };
        const response = await createNewUser(formData);
        if (response?.error) {
          toast.error("Something error...");
        } else {
          navigate("/dashboard/user");
        }
        setError(null);
      } catch (error) {
        setError(error?.response?.data?.error);
      }
    }
  };
  return (
    <div className=" overflow-auto">
      <div className="flex justify-between items-center p-4">
        <h1 className="text-xl font-bold">Create User </h1>
        <Link
          to="/dashboard/user"
          className="bg-blue-500 px-2 py-1 rounded font-medium text-white flex items-center gap-x-1"
        >
          <AiFillBackward /> User List{" "}
        </Link>
      </div>
      <div>
        <div className="p-4 m-4 border">
          <form className=" grid grid-cols-2 lg:grid-cols-3  gap-6">
            <div className="flex flex-col gap-1">
              <label>User Type</label>
              <select
                onChange={(e) => setUserType(e.target.value)}
                className="border h-8 pl-1"
              >
                <option>--select--</option>
                {userType?.map((type, i) => (
                  <option key={i}>{type}</option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Name</label>
              <input
                type="text"
                onChange={(e) => setName(e.target.value)}
                className="border h-8 pl-1"
                required
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Email</label>
              <input
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                className="border h-8 pl-1"
                required
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="border h-8 pl-1"
              />
              {preview && (
                <img
                  src={preview}
                  alt="Preview"
                  style={{ maxWidth: "100%", maxHeight: "200px" }}
                />
              )}
            </div>
            <div className="flex flex-col gap-1">
              <label>Password</label>
              <input
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                required
                className="border h-8 pl-1"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Confirm Password</label>
              <input
                type="password"
                onChange={(e) => setConPassword(e.target.value)}
                className="border h-8 pl-1"
              />
            </div>
          </form>
          {error && (
            <p className="text-center text-red-500 font-bold mt-6">{error}</p>
          )}
          <button
            onClick={handleCreate}
            className="bg-blue-500 px-4 py-1 text-white font-bold block mx-auto mt-4"
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateUser;
